export default function handleYmGoal (name) {
    if (typeof yaCounter45303309 !== 'undefined') {
        // eslint-disable-next-line no-undef
        yaCounter45303309.reachGoal(name)
    }
}
